export default import.meta.ROLLUP_FILE_URL_b_5wRCJ1A3kYkCVU5xGeiQ